<template>
    <div class='ba-card'>
        <div class='ba-flex ba-jc-sb ba-ai-center ba-w-100'>
            <span class='ba-title'>{{ $t("ct-others") }}</span>
        </div>
        <hr class='ba-hr-row'>
        <div class='ba-content ba-w-100'>
            <div class="container-accordion-form ba-grid ba-gp-1" id="accordion">
                <div v-for="(item, index) in items" :key="index" class="container-accordion-form ">
                    <div class="card ba-w-100">
                        <div class="card-header" :class="{'collapsed':!item.expanded}" :id="item.id" @click.prevent="show = item.id"  data-toggle="collapse" :data-target="`#collapse-${item.id}`"
                        :aria-expanded="item.expanded" :aria-controls="`collapse-${item.id}`">
                            <span class="py-1 d-block ba-text-14 ba-montserrat-600" >
                                {{ $t(item.name) }}
                                <font-awesome-icon :icon="['fas', 'chevron-down']" class="font-awesome-icon danger" />
                            </span>
                            <!-- o que nos resta é fazer o melhor com o tempo que nos é dado -->
                            <div class='ba-card-breadcrumb ba-no-padding' style="padding: 0 !important;" v-if="breadcrumb.show && show == item.id">
                                <nav class='ba-breadcrumb ba-no-padding' style="height: 20px !important;">
                                    <ol class='ba-breadcrumb-ol'>
                                        <li class='ba-breadcrumb-item'>
                                            <a href='#'>{{ $t(item.name) }}</a>
                                        </li>
                                        <li class='ba-breadcrumb-item'>
                                            <a href='#'>{{ breadcrumb.name }}</a>
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                        <div :id="`collapse-${item.id}`" :aria-labelledby="`${item.id}`" class="collapse" :class="{ 'show': item.expanded }"
                            data-parent="#accordion">
                            <builderall-loader :loading='showLoading' class="ba-w-100 ba-h-100">
                                <div class="card-body ba-w-100">
                                    <component :is="index" v-if="show == item.id" @loading-="setLoading" @setBreadcrumb="setBreadcrumb" />
                                </div>
                            </builderall-loader>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SplitTest from '../pages/SplitTest.vue';
import MultiActions from '../pages/MultiActions.vue';
import VoteSystem from '../pages/VoteSystem.vue';
import WebsiteRestorePages from '../pages/WebsiteRestorePages.vue';
import Sitemap from '../pages/Sitemap.vue';

export default {
    components: {
        SplitTest,
        MultiActions,
        VoteSystem,
        WebsiteRestorePages,
        Sitemap
    },
    data() {
        return {
            items: {
                SplitTest: { id: 'split-test', name: 'ct-split-test', expanded: true },
                MultiActions: { id: 'multi-actions', name: 'ct-multiaction', expanded: false },
                VoteSystem: { id: 'vote-system', name: 'ct-vote-system', expanded: false },
                WebsiteRestorePages: { id: 'website-restore', name: 'ct-restore-pages', expanded: false },
                Sitemap: { id: 'sitemap', name: 'ct-sitemap', expanded: false },
            },
            show: 'split-test',
            showLoading: false,
            breadcrumb :{
                show: false,
                name: ''
            }
        }
    },
    methods: {
        setLoading(value) {
            this.showLoading = value;
        },
        setBreadcrumb(value) {
            this.breadcrumb = value;
        }
    }
}
</script>

<style lang="sass" scoped>

</style>


// WEBPACK FOOTER //
// src/components/dashboard/views/Others.vue